export type TG = TelegramWebApp | null;

export function getTG(): TG {
  try {
    return window.Telegram?.WebApp ?? null;
  } catch {
    return null;
  }
}

export function initTG() {
  const tg = getTG();
  if (!tg) return null;
  tg.expand();
  tg.ready();
    try {
    // @ts-ignore
    tg.disablePullToRefresh?.();
  } catch {}

  // Поддержка темы
  document.documentElement.style.setProperty(
    "color-scheme",
    tg.colorScheme === "light" ? "light" : "dark"
  );

  // --- 🔥 Анти-сворачивание — дублируем expand на ивенты
  window.addEventListener("blur", () => {
    setTimeout(() => { try { tg.expand(); } catch {} }, 100);
  });

  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") {
      try { tg.expand(); } catch {}
    }
  });
  document.documentElement.style.setProperty(
    "color-scheme",
    tg.colorScheme === "light" ? "light" : "dark"
  );
  return tg;
}

export function getAvatarUrl(): string | null {
  return getTG()?.initDataUnsafe?.user?.photo_url ?? null;
}

export function getUserName(): string {
  const u = getTG()?.initDataUnsafe?.user;
  return u?.first_name ? [u.first_name, u.last_name].filter(Boolean).join(" ") : "User";
}

// haptics
export function vibrate(ms = 20) {
  try { navigator.vibrate?.(ms); } catch {}
  try { getTG()?.HapticFeedback?.impactOccurred("light"); } catch {}
}
export function vibrateSuccess() {
  try { getTG()?.HapticFeedback?.notificationOccurred("success"); } catch {}
  vibrate(30);
}
export function vibrateTick() {
  try { getTG()?.HapticFeedback?.selectionChanged(); } catch {}
}
